import React, { useContext } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { AuthContext } from '../AuthContext';
import { ReactComponent as DashboardIcon } from '../../assets/svg/dashboardnew1.svg'
import { ReactComponent as ACLIcon } from '../../assets/svg/accesscontrol.svg'
import { ReactComponent as MasterIcon } from '../../assets/svg/masters.svg'
import { ReactComponent as InventoryIcon } from '../../assets/svg/inventory.svg'
import { ReactComponent as SalesIcon } from '../../assets/svg/sales.svg'
import { ReactComponent as FinanceIcon } from '../../assets/svg/finance.svg'
import { ReactComponent as ReportsIcon } from '../../assets/svg/reports.svg'
import { Can } from '../../hooks/usePermissions';

const FrachiseeUserSidebar = () => {
    const { user } = useContext(AuthContext);
    const location = useLocation();
    
    // Check if path is active
    const isActive = (path) => location.pathname.includes(path) ? 'active' : '';

    return (
        <div className="pos-sidebar-wrapper" style={{ height: 'calc(100vh - 80px)', overflowY: 'auto' }}>
            <div className="app-nav" id="app-simple-bar" style={{ height: 'auto', overflow: 'visible' }}>
                <ul className="main-nav p-0 mt-2 pb-5">
                    
                    {/* --- 1. CORE POS OPERATIONS --- */}
                    <div className="pos-section-title">Point of Sale</div>
                    
                    <li>
                        <Link to="/franchisee_user/home" className={`pos-menu-item ${isActive('/home')}`}>
                            <DashboardIcon />
                            <span>Dashboard</span>
                        </Link>
                    </li>

                    {/* UPDATED: Points directly to CREATE page now */}
                    <li>
                        <Link to="/franchisee_user/sales/sales-invoices/create" className={`pos-menu-item ${isActive('/sales-invoices/create')}`}>
                            <SalesIcon />
                            <span>New Bill / Invoice</span>
                        </Link>
                    </li>

                    <li>
                        <Link to="/franchisee_user/inventory/stock-view" className={`pos-menu-item ${isActive('/stock-view')}`}>
                            <InventoryIcon />
                            <span>Check Stock</span>
                        </Link>
                    </li>
                    
                     <li>
                        <Link to="/franchisee_user/inventory/stock-conversions" className={`pos-menu-item ${isActive('/stock-conversions')}`}>
                             <i className="ti ti-arrows-exchange f-s-20 me-3"></i>
                            <span>Product Loosening</span>
                        </Link>
                    </li>

                    {/* --- 2. DAILY OPERATIONS --- */}
                    <div className="pos-section-title mt-2">Operations</div>

                    {/* UPDATED: Renamed Group to 'Sales Operations' and added Invoice List */}
                    <li>
                        <a className={`pos-menu-item ${isActive('/sales/')}`} data-bs-toggle="collapse" href="#pos-sales-ops">
                            <i className="ti ti-receipt f-s-20 me-3"></i>
                            <span>Sales Operations</span>
                            <i className="ti ti-chevron-down ms-auto f-s-14"></i>
                        </a>
                        <ul className="collapse pos-submenu list-unstyled" id="pos-sales-ops">
                            {/* NEW: Invoice List is tucked away here */}
                            <li><Link to="/franchisee_user/sales/sales-invoices">Invoice History / List</Link></li>
                            <li><Link to="/franchisee_user/sales/sales-returns">Sales Return</Link></li>
                            <li><Link to="/franchisee_user/sales/credit-notes">Credit Notes</Link></li>
                            <li><Link to="/franchisee_user/sales/debit-notes">Debit Notes</Link></li>
                        </ul>
                    </li>

                    {/* Inventory Management */}
                    <li>
                        <a className={`pos-menu-item ${isActive('/inventory/')}`} data-bs-toggle="collapse" href="#pos-inventory-ops">
                            <i className="ti ti-box-seam f-s-20 me-3"></i>
                            <span>Inventory Management</span>
                            <i className="ti ti-chevron-down ms-auto f-s-14"></i>
                        </a>
                        <ul className="collapse pos-submenu list-unstyled" id="pos-inventory-ops">
                            <li><Link to="/franchisee_user/inventory/purchase-invoices">Purchase Invoice</Link></li>
                            <li><Link to="/franchisee_user/inventory/grn">Goods Received(GRN)</Link></li>
                            <li><Link to="/franchisee_user/inventory/purchase-returns">Purchase Return</Link></li>
                            <li><Link to="/franchisee_user/inventory/opening-balances">Opening Balance</Link></li>
                        </ul>
                    </li>

                    <li>
                        <Link to="/franchisee_user/finance/vouchers" className={`pos-menu-item ${isActive('/vouchers')}`}>
                            <FinanceIcon />
                            <span>Journal Vouchers</span>
                        </Link>
                    </li>

                    {/* --- 3. REPORTS & ADMIN --- */}
                    <div className="pos-section-title mt-2">Back Office</div>

                    <li>
                        <a className={`pos-menu-item ${isActive('/reports/')}`} data-bs-toggle="collapse" href="#pos-reports">
                            <ReportsIcon />
                            <span>Reports</span>
                             <i className="ti ti-chevron-down ms-auto f-s-14"></i>
                        </a>
                        <ul className="collapse pos-submenu list-unstyled" id="pos-reports">
                            <li><Link to="/franchisee_user/reports/sales">Sales Reports</Link></li>
                            <li><Link to="/franchisee_user/reports/inventory">Inventory Reports</Link></li>
                            <li><Link to="/franchisee_user/reports/finance">Finance Reports</Link></li>
                        </ul>
                    </li>

                    <li>
                        <a className={`pos-menu-item ${isActive('/masters/')}`} data-bs-toggle="collapse" href="#pos-masters">
                            <MasterIcon />
                            <span>Masters</span>
                             <i className="ti ti-chevron-down ms-auto f-s-14"></i>
                        </a>
                        <ul className="collapse pos-submenu list-unstyled" id="pos-masters">
                             <Can any={['view-hoa']}>
                                <li><Link to="/franchisee_user/masters/hoas">Head of Accounts</Link></li>
                            </Can>
                            <li><Link to="/franchisee_user/masters/products">Products</Link></li>
                            <li><Link to="/franchisee_user/masters/parties">Parties (Customers)</Link></li>
                            <li><Link to="/franchisee_user/masters/partygroups">Party Groups</Link></li>
                            <Can any={['view-uom']}>
                                <li><Link to="/franchisee_user/masters/uoms">UOM</Link></li>
                            </Can>
                            <li><Link to="/franchisee_user/masters/rate-types">Rate Types</Link></li>
                            <li><Link to="/franchisee_user/masters/rates">Rates</Link></li>
                        </ul>
                    </li>

                    <li>
                        <a className={`pos-menu-item ${isActive('/users')}`} data-bs-toggle="collapse" href="#pos-access">
                            <ACLIcon />
                            <span>Settings & Users</span>
                             <i className="ti ti-chevron-down ms-auto f-s-14"></i>
                        </a>
                        <ul className="collapse pos-submenu list-unstyled" id="pos-access">
                            <Can any={['view-user']}>
                                <li><Link to="/franchisee_user/users">Manage Users</Link></li>
                            </Can>
                        </ul>
                    </li>
                    
                    <li style={{ height: '100px' }}></li>

                </ul>
            </div>
        </div>
    )
}

export default FrachiseeUserSidebar